import React, { FunctionComponent, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type FC = FunctionComponent;

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};

const FiservError: FC = () => {
  const params = useQuery();

  useEffect(() => { 
    if(params.get('errorCode')){
      window.parent.postMessage({
        step: "FISERV_ERROR",
        errorCode: params.get('errorCode') || "",
      }, '*');
    }
    if(params.get('action')){
      window.parent.postMessage({
        step: "FISERV_CANCEL",
        action: params.get('action') || "",
      }, '*');
    }
  }, [params]);

  return (
    <></>
  );
};

export default FiservError;